import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=2198a4fc&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=2198a4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198a4fc",
  null
  
)

export default component.exports